import { render } from "./BomHeaderPrice.vue?vue&type=template&id=0bf3b35e&scoped=true"
import script from "./BomHeaderPrice.vue?vue&type=script&lang=js"
export * from "./BomHeaderPrice.vue?vue&type=script&lang=js"

import "./BomHeaderPrice.vue?vue&type=style&index=0&id=0bf3b35e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf3b35e"]])

export default __exports__